import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { stripLocalePrefix } from "lib/i18n/path";
import { useLocalizedNavigate } from "lib/i18n/navigation";

import { isRequestWaiting } from "./site-assistant";
import { useMySiteAssistant } from "./site.hooks";
import { SITE_ASSISTANT_REQUEST_ROUTE } from "./site.routes";

// A "Підключити Claude" request waits for an answer: the app shows its page from a push, or when
// it comes to the foreground. The admin has no push, so it looks when its tab is back in front
// (the Provider returns from Claude's tab) and opens the request page once per request.
export function SiteAssistantRequestPrompt() {
  const { data, refetch } = useMySiteAssistant();
  const navigate = useLocalizedNavigate();
  const { pathname } = useLocation();
  const prompted = useRef(new Set<string>());
  const request = data?.mySiteAssistant.pendingRequest ?? null;
  const onRequestPage = stripLocalePrefix(pathname).pathname === SITE_ASSISTANT_REQUEST_ROUTE;

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") void refetch().catch(() => undefined);
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
    };
  }, [refetch]);

  useEffect(() => {
    if (!request || !isRequestWaiting(request) || prompted.current.has(request.uuid)) return;
    prompted.current.add(request.uuid);
    if (!onRequestPage) navigate(SITE_ASSISTANT_REQUEST_ROUTE);
  }, [navigate, onRequestPage, request]);

  return null;
}
